import { AnyAction, Reducer } from "redux";

import { WebchatEventListenerState } from "./definitions";
import { ACTION_ADD_WEBCHAT_EVENT_LISTENER, ACTION_REMOVE_WEBCHAT_EVENT_LISTENER } from "./actions/actionTypes";

const initialState: WebchatEventListenerState = {
    listeners: []
};

export const webchatEventListenerReducer: Reducer<WebchatEventListenerState, AnyAction> = (
    state: WebchatEventListenerState = initialState,
    action: AnyAction
): WebchatEventListenerState => {
    switch (action.type) {
        case ACTION_ADD_WEBCHAT_EVENT_LISTENER: {
            return {
                ...state,
                listeners: [
                    ...state.listeners,
                    {
                        [action.payload.event]: action.payload.listenerCb
                    }
                ]
            };
        }
        case ACTION_REMOVE_WEBCHAT_EVENT_LISTENER: {
            return {
                ...state,
                listeners: state.listeners.filter((listener) => !listener.hasOwnProperty(action.payload))
            };
        }

        default:
            return state;
    }
};
